import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { WorkflowConfigurationService } from "../services/workflowconfiguration.service";
import { Observable } from "rxjs";
import { IWorkflow } from "../interfaces/iworkflow";

@Injectable()
export class WorkflowConfigurationResolver implements Resolve<IWorkflow> {
    constructor(private workflowconfigurationservice: WorkflowConfigurationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IWorkflow> {
        const countryCode: string = route.params["countrycode"];
        return this.workflowconfigurationservice.getWorkflowConfiguration(countryCode);
    }
}
